import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminMowerDuplicates from "@/pages/admin/AdminMowerDuplicates";

export const Route = createFileRoute("/admin/lawn-mowers/duplicates")({
  component: () => (
    <ProtectedRoute>
      <AdminMowerDuplicates />
    </ProtectedRoute>
  ),
});
